import { ArrayUtils, Encoder, Utils } from '@everyboard/lib';
import { Move } from '../../../jscaip/Move';
export class MancalaDistribution {
    x;
    y;
    static encoder = Encoder.tuple([Encoder.identity(), Encoder.identity()], (distribution) => [distribution.x, distribution.y], (value) => MancalaDistribution.of(value[0], value[1]));
    static of(x, y) {
        Utils.assert(0 <= x, 'MancalaDistribution.x should be a positive integer!');
        Utils.assert(0 <= y, 'MancalaDistribution.y should be a positive integer!');
        return new MancalaDistribution(x, y);
    }
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
    equals(other) {
        if (other === this)
            return true;
        if (other.x !== this.x)
            return false;
        return other.y === this.y;
    }
}
export class MancalaMove extends Move {
    distributions;
    static encoder = Encoder.tuple([Encoder.list(MancalaDistribution.encoder)], (move) => [move.distributions], (value) => MancalaMove.of(value[0][0], value[0].slice(1)));
    static of(mandatoryDistribution, bonusDistributions = []) {
        const distributions = [mandatoryDistribution];
        distributions.push(...bonusDistributions);
        return new MancalaMove(distributions);
    }
    constructor(distributions) {
        super();
        this.distributions = distributions;
        Utils.assert(distributions.length > 0, 'Move should have distribution ');
    }
    add(move) {
        return MancalaMove.of(this.distributions[0], this.distributions.slice(1).concat(move));
    }
    toString() {
        const distributions = this.distributions.map((move) => '(' + move.x + ', ' + move.y + ')');
        return 'MancalaMove([' + distributions.join(', ') + '])';
    }
    equals(other) {
        return ArrayUtils.equals(this.distributions, other.distributions);
    }
    getFirstDistribution() {
        return this.distributions[0];
    }
    [Symbol.iterator]() {
        return this.distributions.values();
    }
}
